import React from 'react';
import PropTypes from 'prop-types';

const NavBar = (props) => {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
    <div className="container-fluid">
    <a className="navbar-brand" href="/">{props.title}</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="/">Home</a>
        </li>
      </ul>
      {/* <form className="d-flex" role="search">
        <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button className="btn btn-primary" type="submit">Search</button>
      </form> */}
        {/* <div className="mx-4">
        <i className="bi bi-circle-fill mx-2 text-primary" onclick={props.primaryMode}></i>
        <i className="bi bi-circle-fill mx-2 text-success"></i>
        <i className="bi bi-circle-fill mx-2 text-warning"></i>
        <i className="bi bi-circle-fill mx-2 text-danger"></i>
        <i className="bi bi-circle-fill mx-2 text-info"></i>
        </div> */}
        <div className={`form-check form-switch text-${(props.mode==="light")?"dark":"light"}`}>
        <input className="form-check-input" type="checkbox" onClick={props.toggleMode} /*role="switch"*/ id="flexSwitchCheckDefault"/>
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{`${(props.mode==="light")?"Enable Dark Mode":"Enable Light Mode"}`}</label>
        </div>
    </div>
  </div>
</nav>
  )
}

export default NavBar;

NavBar.propTypes = {
  title: PropTypes.string.isRequired,
  textAbout: PropTypes.string.isRequired
}

 NavBar.defaultProps = {
  title:"Set title here",
  textAbout:"About text here"
};